"use client";

import { c as _c } from "react/compiler-runtime";
import { PortfolioUnitGrid } from "@/components/molecules/portfolio-unit-grid/PortfolioUnitGrid";
import type { PortfolioRoomsResult } from "@/components/modules/portfolio/hooks/usePortfolioUtils";
import { useAssociateUnitStep } from "./useAssociateUnitStep";
type Props = {
  resource: PortfolioRoomsResult;
  currentUnitId?: string | null;
  currentLabel?: string;
};
export function AssociateUnitStep(t0) {
  const $ = _c(6);
  const {
    resource,
    currentUnitId,
    currentLabel
  } = t0;
  const {
    selectedUnitId,
    handleSelectUnit
  } = useAssociateUnitStep(currentUnitId);
  let t1;
  if ($[0] !== currentLabel || $[1] !== currentUnitId || $[2] !== handleSelectUnit || $[3] !== resource || $[4] !== selectedUnitId) {
    t1 = <div className="p-2" data-sentry-component="AssociateUnitStep" data-sentry-source-file="AssociateUnitStep.tsx"><PortfolioUnitGrid resource={resource} selectedUnitId={selectedUnitId} currentUnitId={currentUnitId} currentLabel={currentLabel} desktopColumns={5} onSelectUnit={handleSelectUnit} data-sentry-element="PortfolioUnitGrid" data-sentry-source-file="AssociateUnitStep.tsx" /></div>;
    $[0] = currentLabel;
    $[1] = currentUnitId;
    $[2] = handleSelectUnit;
    $[3] = resource;
    $[4] = selectedUnitId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}